/* ARDAS product page - gallery thumbnails + variant selection.
 * Lightweight vanilla JS, no dependencies. Runs only when a PDP is present. */
(function () {
  'use strict';
  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  /* ---- Gallery: thumbnail -> main image ---- */
  var main = pdp.querySelector('[data-pdp-main]');
  var thumbs = pdp.querySelectorAll('[data-pdp-thumbs] .pdp__thumb');
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var full = btn.getAttribute('data-full');
      if (main && full) main.src = full;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ---- Variants ---- */
  var json = pdp.querySelector('[data-pdp-variants-json]');
  var variants = [];
  try { variants = JSON.parse(json.textContent); } catch (e) { return; }
  var swatches = pdp.querySelectorAll('.pdp__swatch');
  if (!swatches.length) return;

  var selected = [];
  pdp.querySelectorAll('.pdp__option').forEach(function (opt, i) {
    var active = opt.querySelector('.pdp__swatch.is-active') || opt.querySelector('.pdp__swatch');
    selected[i] = active ? active.getAttribute('data-value') : null;
  });

  var priceEl = pdp.querySelector('[data-price]');
  var compareEl = pdp.querySelector('[data-compare]');
  var idInput = pdp.querySelector('[data-variant-id]');
  var atc = pdp.querySelector('[data-atc]');
  var atcText = pdp.querySelector('[data-atc-text]');

  function money(cents) {
    return 'Rs.' + (cents / 100).toLocaleString('en-IN');
  }

  function findVariant() {
    return variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    })[0] || null;
  }

  function update() {
    var v = findVariant();
    if (!v) return;
    if (priceEl) priceEl.textContent = money(v.price);
    if (compareEl) compareEl.style.display = (v.compare_at_price > v.price) ? '' : 'none';
    if (idInput) idInput.value = v.id;
    if (atc) {
      atc.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? 'Add to Bag' : 'Sold out';
    }
    if (main && v.featured_media && v.featured_media.preview_image) {
      main.src = v.featured_media.preview_image.src;
    }
  }

  swatches.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      selected[idx] = btn.getAttribute('data-value');
      pdp.querySelectorAll('.pdp__swatch[data-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      update();
    });
  });
})();
